import React from 'react';
import { connect } from 'react-redux';
import ReservedSpotMarker from './ReservedSpotMarker';
import { SHOW_PARKING_SPOTS_ZOOM_LEVEL } from '../../constants';

const ReservedParkingSpotsMarkerList = ({reservedSpots, zoomLevel}) => {
  if(zoomLevel >= SHOW_PARKING_SPOTS_ZOOM_LEVEL) {
    return <div />;
  }

  const reservedSpotsMarkers = reservedSpots.map((spotId) => {
    return <ReservedSpotMarker key={spotId} spotId={spotId} />;
  });

  return (
    <div>{reservedSpotsMarkers}</div>
  );
};

const mapStateToProps = ({ map, userAccommodationInfo }) => ({
  zoomLevel: map.zoomLevel,
  reservedSpots: userAccommodationInfo.reservedSpots
});

export default connect(mapStateToProps)(ReservedParkingSpotsMarkerList);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ReservedParkingSpotsMarkerList.js